import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Card, message } from "antd";

import storageUtils from "../../utils/storageUtils";
import { req_add_eca_activity_participate } from "../../api";

class EnglishActivityParticipateAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    activity: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    item: {
      activityNid: 0, //this.props.activity.activityNid
      teamGroup: "不分組別",
      selfTeamType: "SELF",
      selfTeamName: "", //participantsName
      checkStatus: "PRIMARY",
      participantsCode: "",
      participantsName: "",
      participantsDepart: "",
      participantsSubDepart: "",
      participantsGroup: "在校學生",
      mealChoice: "SELFPREARED",
      displayInfo: "HIDE",
      hasCertificate: "N",
      trafficType: "WALK",
      pickupService: "N",
      receipt: "無",
      payment: "0",
      phone: "",
      registerWays: "現場報名",
      beenLeave: "N",
      signStatus: "YET",
      activitySource: "LOCAL",
      getPoints: 1,
      getGrade: 0,
    },
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {}
  // 遠端數據處理 //////////////////////////////////////////////

  api_add_item = async (item) => {
    const result = await req_add_eca_activity_participate(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        item[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    const row = this.state.item;
    const errors = [];

    if (!row.participantsCode.trim()) {
      errors.push("學號未填");
    }

    if (errors.length === 0) {
      row.activityNid = this.props.activity.activityNid;
      row.selfTeamName = row.participantsName;
      row.getPoints = this.props.activity.setPoints;
      // console.log(row)
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  /////////////////////////////////////////////////////////////
  render() {
    //console.log(this.props.activity)
    const {
      participantsCode,
      participantsName,
      participantsDepart,
      participantsSubDepart,
    } = this.state;
    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>學號
                </label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="participantsCode"
                  id="participantsCode"
                  defaultValue={participantsCode}
                  aria-describedby="mobileHelp"
                  placeholder="請輸入學號"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-lg">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>姓名
                </label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="participantsName"
                  id="participantsName"
                  defaultValue={participantsName}
                  aria-describedby="mobileHelp"
                  placeholder="請輸入姓名"
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>系所
                </label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="participantsDepart"
                  id="participantsDepart"
                  defaultValue={participantsDepart}
                  aria-describedby="mobileHelp"
                  placeholder="請輸入系所"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-lg">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>班級
                </label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="participantsSubDepart"
                  id="participantsSubDepart"
                  defaultValue={participantsSubDepart}
                  aria-describedby="mobileHelp"
                  placeholder="請輸入班級"
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-warning btn-sm btn-block"
                >
                  <i className="fas fa-user-plus"></i>
                  <span style={{ marginLeft: "4px" }}>增加</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(EnglishActivityParticipateAddModal);
